import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OfferCard.css';

interface Offer {
  id: string;
  name: string;
  description: string;
  icon: string | null;
  type: string;
  action: string;
  featured?: boolean;
  payout?: number;
  category?: string;
  isInProgress?: boolean;
}

interface GameOfferCardProps {
  offer: Offer;
}

const GameOfferCard: React.FC<GameOfferCardProps> = ({ offer }) => {
  const navigate = useNavigate();

  const formatDescription = (text: string): string => {
    if (!text) return '';
    const sentences = text.split(/(?<=[.!?])\s+/);
    return sentences.map(sentence => {
      const trimmed = sentence.trim();
      if (!trimmed) return '';
      return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
    }).join(' ');
  };

  const handleCardClick = (e: React.MouseEvent) => {
    // Navigate to the app details page
    navigate(`/app/${offer.id}`);
  };

  return (
    <div className={`offer-card ${offer.featured ? 'featured' : ''}`} onClick={handleCardClick}>
      <div className="offer-content">
        <div className="offer-icon">
          {offer.icon ? (
            <img src={offer.icon} alt={offer.name} />
          ) : (
            <div className="offer-icon-placeholder">
              <span>{offer.name.charAt(0)}</span>
            </div>
          )}
        </div>
        <div className="offer-details">
          <h3 className="offer-name">{offer.name}</h3>
          <p className="offer-description">{formatDescription(offer.description)}</p>
        </div>
      </div>
      <button className="offer-action-btn" onClick={handleCardClick}>
        <span>{offer.isInProgress ? 'Continue' : 'View'}</span>
      </button>
    </div>
  );
};

export default GameOfferCard;